<agr-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div class="flex--column spacing--margin-top">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'barn' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="barn"
        data-test="switch-day-edit-item__barn"
      >
        <mat-option *ngFor="let barnMapping of data.barnMappings" [value]="barnMapping">
          {{ barnMapping.barnName }} - {{ barnMapping.animalGroupBarnId }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'animal-group.phaseFrom' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="1"
        formControlName="phaseFrom"
        placeholder="{{ 'animal-group.phaseFrom' | translate }}"
        data-test="switch-day-edit-item__phaseFrom"
      />
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'animal-group.phaseTo' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="1"
        formControlName="phaseTo"
        placeholder="{{ 'animal-group.phaseTo' | translate }}"
        data-test="switch-day-edit-item__phaseFrom"
      />
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'animal-group.date' | translate }}</mat-label>
      <input
        matInput
        formControlName="date"
        [matDatepicker]="vaccinationDatePicker"
        placeholder="{{ 'animal-group.date' | translate }}"
        data-test="vaccination-edit-item__date"
      />
      <mat-datepicker-toggle matIconSuffix [for]="vaccinationDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #vaccinationDatePicker></mat-datepicker>
    </mat-form-field>
  </div>
</agr-dialog>
